import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'User',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'userId',
        'name',
        'roleKbn',
        'service',
        'linkedCmss',
        'lastLoginAt',
        'status',
        'detailButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          userId: 'アカウントID',
          name: 'アカウント名',
          roleKbn: '管理者区分',
          service: 'サービス名',
          linkedCmss: '連携CMS名',
          lastLoginAt: '最終ログイン日時',
          status: 'ステータス',
          detailButton: ''
        },
        columnsClasses: {
          userId: 'wp-5',
          name: '',
          roleKbn: '',
          service: '',
          linkedCmss: '',
          lastLoginAt: '',
          status: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'userId',
          'name',
          'roleKbn',
          'service',
          'linkedCmss',
          'status'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // // 検索
      // searchUserName: null,
      // searchMailAddress: null,
      // searchUserType: '',
      // searchService: '',
      // searchStatus: '',

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  beforeDestroy() {
    console.log(this.$route.name)
    if (this.$route.name !== 'UserForm') {
      this.reset()
    }
  },
  computed: {
    ...mapState({
      categoryName: state => state.user.categoryName,
      userModel: state => state.user.userModel,
      serviceModel: state => state.user.serviceModel,

      // 検索
      filters: state => state.user.filters,
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // search
    userTypeList () {
      return Constants.UserRole
        .filter(item => {
          return this.isAdmin
            ? true
            : item.value !== 1
        })
        .map(item => {
          return {
            value: item.value,
            label: item.label
          }
        })
    },
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },
    serviceList () {
      let list = []
      this.serviceModel
        .filter(item => item.serviceStatus === 1)
        .forEach(item => list.push({
        value: item.serviceUuid,
        label: item.serviceName
      }))
      return list
    },

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // filter
    searchUserName: {
      get () {
        return this.filters.searchUserName
      },
      set (value) {
        this.setInputFilter({
          key: 'searchUserName',
          value: value
        })
      }
    },
    searchMailAddress: {
      get () {
        return this.filters.searchMailAddress
      },
      set (value) {
        this.setInputFilter({
          key: 'searchMailAddress',
          value: value
        })
      }
    },
    searchUserType: {
      get () {
        return this.filters.searchUserType
      },
      set (value) {
        this.setInputFilter({
          key: 'searchUserType',
          value: value
        })
      }
    },
    searchService: {
      get () {
        return this.filters.searchService
      },
      set (value) {
        this.setInputFilter({
          key: 'searchService',
          value: value
        })
      }
    },
    searchStatus: {
      get () {
        return this.filters.searchStatus
      },
      set (value) {
        this.setInputFilter({
          key: 'searchStatus',
          value: value
        })
      }
    },
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'user/loadModel',
      loadUserList: 'user/loadUserList',
      reset: 'user/reset'
    }),
    ...mapMutations({
      setInputFilter: 'user/setInputFilter',
    }),

    init () {
      this.loading = true

      //
      let userParams = {
        filters: {}
      }
      if (this.searchUserName !== null)
        userParams.filters.name = this.searchUserName
      if (this.searchMailAddress !== null)
        userParams.filters.email = this.searchMailAddress
      if (this.searchUserType !== '')
        userParams.filters.roleKbn = this.searchUserType
      if (this.searchService !== '')
        userParams.filters.serviceUuid = this.searchService
      if (this.searchStatus !== '')
        userParams.filters.status = this.searchStatus
      let serviceParams = {}

      // サービス運用者の場合、自身のサービスに限定
      if (this.isOperator) {
        this.searchService = this.userServiceUuid
        userParams.filters.serviceUuid = this.searchService
      }

      // データ読出し
      this.loadModel({
        userParams: userParams,
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.userModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'roleKbn':
          return Utility.getConstantsLabel(['UserRole'], value)
        case 'service':
          return value ? value.serviceName : Constants.BlankValue
        case 'linkedCmss':
          if (!value || !value.length) return Constants.BlankValue
          var list = []
          value.forEach(item => list.push(item.linkedCmsName))
          return list.join('、')
        case 'lastLoginAt':
          return Utility.dateFormat(value, 'YYYY/MM/DD HH:mm')
        case 'status':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      this.searchUserName = null
      this.searchMailAddress = null
      this.searchUserType = ''
      this.searchService = ''
      this.searchStatus = ''

      this.init()
    },
    search () {
      this.loading = true

      //
      let userParams = {
        filters: {}
      }
      if (this.searchUserName !== null)
        userParams.filters.name = this.searchUserName
      if (this.searchMailAddress !== null)
        userParams.filters.email = this.searchMailAddress
      if (this.searchUserType !== '')
        userParams.filters.roleKbn = this.searchUserType
      if (this.searchService !== '')
        userParams.filters.serviceUuid = this.searchService
      if (this.searchStatus !== '')
        userParams.filters.status = this.searchStatus

      // データ読出し
      this.loadUserList({
        userParams: userParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.userModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    detailItem (props) {
      this.$router.push({
        name: 'UserForm',
        params: {
          userId: String(props.row.userUuid)
        }
      })
    }
  }
}